// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cbp-tm-menu{display:inline-block}`, "",{"version":3,"sources":["webpack://./src/containers/Forms/_calendarEvent.scss"],"names":[],"mappings":"AAAA,aACC,oBAAA","sourcesContent":[".cbp-tm-menu {\n\tdisplay: inline-block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
